import { DeviceV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/device-v2-controller-api";
import { DeviceLinkClaimV2ControllerApi } from "@generated/n3-backend-api/n3-backend-open-api-gen/device-link-claim-v2-controller-api";
import { inject, injectable } from "inversify";
import { makeObservable } from "mobx";
import DeviceService, {
  type DeviceLinkClaimRequest,
  type PropertyProfile,
} from "@/src/application/services/device-service";

@injectable()
export default class DeviceServiceImpl extends DeviceService {
  constructor(
    @inject(DeviceV2ControllerApi) private readonly deviceApi: DeviceV2ControllerApi,
    @inject(DeviceLinkClaimV2ControllerApi)
    private readonly deviceLinkClaimsApi: DeviceLinkClaimV2ControllerApi
  ) {
    super();
    makeObservable(this);
  }

  public async fetchAllDevices() {
    const response = await this.deviceApi.getDevices();
    return response.data.devices;
  }

  public async fetchDeviceById(id: number) {
    const response = await this.deviceApi.getDevice(id);
    return response.data;
  }

  public async fetchDeviceLinkSuggestions() {
    const response = await this.deviceLinkClaimsApi.getSuggestions();
    return response.data;
  }

  public async claimDeviceLinks(request: DeviceLinkClaimRequest) {
    const response = await this.deviceLinkClaimsApi.claimDevices(request);
    return response.data;
  }

  public async updateDevicePropertyProfile(id: number, propertyProfile: PropertyProfile) {
    await this.deviceApi.updateDevicePropertyProfile(id, { propertyProfile });
  }
}
